import { useGetAffiliateUserStatusQuery } from '../../store/api/affiliateApi';

/** Every affiliate sees this — and it is all that shows while the status loads. */
const MARKETING = '/affiliate/marketing';
const DASHBOARD = '/affiliate';
/** The partner-programme pages a retainer-only affiliate doesn't get. */
const PROGRAMME = ['/affiliate/giveaway', '/affiliate/winner-submission', '/affiliate/personal-account'];
const RETAINER = '/affiliate/retainer';

/**
 * What the trader may see and do in Affiliate, from `/affiliate/user/status/`
 * (`is_super_affiliate`, `is_retainer`):
 *
 *   super affiliate only   every page except Retainer        may apply
 *   retainer only          Dashboard, Retainer, Marketing     may not apply
 *   both                   every page                         may apply
 *   neither                Affiliate Marketing only           may apply
 *
 * If the status can't be read, only Affiliate Marketing shows — the rest
 * opens once the call answers.
 */
export default function useAffiliateAccess() {
  const { data, isSuccess, isError } = useGetAffiliateUserStatusQuery();

  const isSuper = Boolean(data?.is_super_affiliate);
  const isRetainer = Boolean(data?.is_retainer);
  const retainerOnly = isSuccess && isRetainer && !isSuper;

  const allowed = new Set([MARKETING]);
  if (isSuccess && (isSuper || isRetainer)) {
    allowed.add(DASHBOARD);
    if (isSuper) PROGRAMME.forEach((to) => allowed.add(to));
    if (isRetainer) allowed.add(RETAINER);
  }

  return {
    /** Whether the answer is in — no redirects before it. */
    ready: isSuccess || isError,
    canSee: (to) => allowed.has(to),
    /** Where the section opens: its Dashboard, or Affiliate Marketing when that's all there is. */
    home: allowed.has(DASHBOARD) ? DASHBOARD : MARKETING,
    /** A retainer who isn't a Super Affiliate can't apply to become one. */
    canApply: !retainerOnly,
  };
}
